<template>
  <div>
    <div class="floating-ai-wrapper">
      <a
        href="https://ohyes.ai/"
        target="_blank"
        rel="noopener noreferrer"
        class="floating-ai-button"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
      >
        <div class="ai-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <!-- AI Sparkle Icon -->
            <path
              d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z"
            />
            <path
              d="M19 4L19.5 5.5L21 6L19.5 6.5L19 8L18.5 6.5L17 6L18.5 5.5L19 4Z"
              opacity="0.7"
            />
            <path
              d="M5 16L5.5 17.5L7 18L5.5 18.5L5 20L4.5 18.5L3 18L4.5 17.5L5 16Z"
              opacity="0.7"
            />
          </svg>
        </div>

        <transition name="fade-slide">
          <div v-if="isHovered" class="ai-tooltip">
            <span class="tooltip-text">Smart Help With</span>
            <span class="tooltip-brand">
              <span class="oh">oh</span><span class="yes">yes</span>
              <span class="ai-badge">AI</span>
            </span>
          </div>
        </transition>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "OhYesAi",
  data() {
    return {
      isHovered: false,
    };
  },
};
</script>

<style scoped>
.floating-ai-wrapper {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
}

.floating-ai-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #f46523 0%, #6366f1 100%);
  border-radius: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.floating-ai-button:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.floating-ai-button:active {
  transform: scale(0.95);
}

.ai-icon {
  width: 32px;
  height: 32px;
  color: white;
}

.ai-tooltip {
  position: absolute;
  right: 75px;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  padding: 12px 16px;
  border-radius: 12px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  pointer-events: none;
}

.ai-tooltip::after {
  content: "";
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid white;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
}

.tooltip-text {
  display: block;
  font-size: 12px;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
}

.tooltip-brand {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 18px;
  font-weight: 700;
}

.oh {
  color: #f46523;
}

.yes {
  color: #6366f1;
}

.ai-badge {
  display: inline-block;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
}

/* Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(10px) translateY(-50%);
}

/* Responsive */
@media (max-width: 768px) {
  .floating-ai-wrapper {
    bottom: 20px;
    right: 20px;
  }

  .floating-ai-button {
    width: 56px;
    height: 56px;
  }

  .ai-icon {
    width: 28px;
    height: 28px;
  }

  .ai-tooltip {
    right: 65px;
    padding: 10px 14px;
  }

  .tooltip-brand {
    font-size: 16px;
  }
}

.floating-ai-button:focus {
  outline: 3px solid #f46523;
  outline-offset: 3px;
}

.floating-ai-button:focus:not(:focus-visible) {
  outline: none;
}
</style>
